// CorporateDashboardContainer.jsx
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";
import CorporateDashboard from "./component";

const CorporateDashboardContainer = (props) => {
  const { corporateId } = useParams();
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (corporateId) {
      handleGetCorporateDashboard();
    }
  }, [corporateId]);

  const handleGetCorporateDashboard = () => {
    if (loading) return;
    
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v2/corporate/${corporateId}/dashboard`,
      "GET",
      undefined,
      (response) => {
        if (response) {
          setDashboardData(response);
        } else {
          toastr.error("Error", "No dashboard data received");
        }
        setLoading(false);
      },
      (err) => {
        console.error("Failed to fetch corporate dashboard:", err);
        toastr.error("Failed", "Unable to fetch corporate dashboard data");
        setLoading(false);
      }
    );
  };

  return (
    <CorporateDashboard 
      dashboardData={dashboardData}
      loading={loading}
    />
  );
};

export default connect(null, { getDataFromAPI })(CorporateDashboardContainer);